import { Tooltip } from '@material-ui/core';
import React from 'react';

import { getFileType, getIconByFileType, getShortName } from '@utils/Util';

const GetTypeWiseDocuments = ({ documents, title, fieldName }) => {
	const renderTypeWiseDocuments = () => {
		const documentList = documents[fieldName] || [];
		if (documentList.length > 0) {
			return (
				<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
					<p className="gray_dark_02 regular-14">{title}</p>
					{documentList?.map((item) => {
						let fileType;
						if (item.docUrl) {
							fileType = getFileType(item.docUrl);
						} else {
							fileType = getFileType(item.name);
						}
						return (
							<div
								key={`document_${item.id}`}
								className="addition-info d-flex align-items-center pt-1 cursor-pointer"
								onClick={() => window.open(item.docUrl, '_blank')}
							>
								<img src={getIconByFileType(fileType)} width={19} alt="" />
								<Tooltip title={item?.name} placement="top" arrow>
									<p className="regular-12 pl-1">{getShortName(item.name, 11)}</p>
								</Tooltip>
							</div>
						);
					})}
				</div>
			);
		}
	};

	return <>{renderTypeWiseDocuments()}</>;
};

export default GetTypeWiseDocuments;
